import { render, staticRenderFns } from "./CursorMagnet.vue?vue&type=template&id=6d9cc4c0&"
import script from "./CursorMagnet.vue?vue&type=script&lang=js&"
export * from "./CursorMagnet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports